export default __webpack_public_path__ + "static/media/box1_bak2.d03ea22e.png";